// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__gUnSb","selected":"Chip_selected__10hZm"};